interface Props {
  [key: string]: any
}

export default function InfoIIcon(props: Props): React.ReactElement {
  const { pathClassName, ...rest } = props
  return (
    <svg fill="none" viewBox="0 0 4 21" {...rest} xmlns="http://www.w3.org/2000/svg">
      <path
        className={pathClassName ? `fill-current ${pathClassName}` : ''}
        d="M1.883 0.007 C 0.982 0.059,0.222 0.718,0.043 1.604 C -0.008 1.857,-0.008 2.143,0.043 2.396 C 0.166 3.005,0.571 3.526,1.130 3.796 C 1.409 3.931,1.683 3.994,1.993 3.995 C 2.190 3.995,2.353 3.974,2.534 3.924 C 3.205 3.739,3.744 3.198,3.926 2.524 C 3.976 2.342,3.995 2.193,3.995 1.997 C 3.994 1.535,3.845 1.111,3.555 0.750 C 3.227 0.341,2.745 0.074,2.229 0.017 C 2.114 0.005,1.989 0.001,1.883 0.007 M1.877 5.884 C 1.514 5.906,1.260 5.979,1.040 6.125 C 0.937 6.193,0.816 6.314,0.747 6.416 C 0.601 6.635,0.525 6.899,0.507 7.250 C 0.498 7.422,0.498 18.956,0.507 19.128 C 0.518 19.335,0.545 19.494,0.597 19.653 C 0.700 19.965,0.898 20.197,1.183 20.337 C 1.422 20.454,1.765 20.511,2.125 20.493 C 2.573 20.471,2.887 20.353,3.120 20.120 C 3.353 19.887,3.471 19.574,3.493 19.124 C 3.502 18.949,3.502 7.429,3.493 7.254 C 3.471 6.805,3.354 6.494,3.120 6.259 C 2.961 6.100,2.779 6.002,2.523 5.940 C 2.342 5.895,2.077 5.872,1.877 5.884 "
        fill="black"
        fillRule="evenodd"
        stroke="none"
      />
    </svg>
  )
}
